module.exports = __webpack_public_path__ + "static/media/Default.094d39ad.svg";